module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av437-3a24ec00292457f0c23fe8ad66c063ee.jpg";